import { render, staticRenderFns } from "./PopupOrder.vue?vue&type=template&id=40432cf6&"
import script from "./PopupOrder.vue?vue&type=script&lang=js&"
export * from "./PopupOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports